import React, { useState } from "react";
import config from "../../../config/domain";
import { Link, NavLink } from "react-router-dom";
import { RoutesUrl } from "../../Routes/constents";

const HeaderUnTnc = ({ logout, isNavbar, showNavbar }) => {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuName) => {
    setOpenMenu((prev) => (prev === menuName ? null : menuName));
  };

  const closeMenu = () => {
    setOpenMenu(null);
  };

  const handleMenuKeyDown = (e) => {
    if (e.key !== "Tab" || !isNavbar) return;

    const closeButton = document.querySelector(".nav-toggle-btn");
    const menuElements = Array.from(document.querySelectorAll(
      ".mobileView a, .mobileView button, .mobileView [tabindex='0']"
    ));

    const allFocusable = closeButton ? [closeButton, ...menuElements] : menuElements;

    if (!allFocusable.length) return;

    const firstElement = allFocusable[0];
    const lastElement = allFocusable[allFocusable.length - 1];

    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    } else if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }
  };

  return (
    <>
      <div className="navbar-menu">
        {/* Mobile View */}
        <div
          className={isNavbar ? "mobileView" : "hide_nav"}
          onKeyDown={handleMenuKeyDown}
        >
          <div>
            <ul onClick={showNavbar}>
              {/* Documentation */}
              <li
                className={`nav-sub-container ${
                  openMenu === "mobile-docs" ? "open" : ""
                }`}
                onMouseEnter={() => setOpenMenu("mobile-docs")}
                onMouseLeave={closeMenu}
              >
                <a
                  href="javascript:void(0)"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("mobile-docs");
                  }}
                  onFocus={() => setOpenMenu("mobile-docs")}
                >
                  Documentation
                </a>

                <ul className="nav-sublink">
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={config.jmw_client_docs}
                    >
                      Client Documentation
                    </a>
                  </li>

                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={config.jmw_partner_docs}
                    >
                      Partner Documentation
                    </a>
                  </li>
                </ul>
              </li>

              {/* Resources */}
              <li>
                <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
                  Resources
                </NavLink>
              </li>

              {/* Support */}
              <li>
                <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
                  Support
                </NavLink>
              </li>

              {/* Logout */}
              <li onClick={logout}>
                <NavLink to="#">
                  <i className="edel-icon-logout"></i> Logout
                </NavLink>
              </li>

              {/* Get Started */}
              <li>
                <NavLink
                  exact
                  activeClassName="active"
                  to={RoutesUrl.TermsAndConditions}
                  className="btn"
                >
                  Get Started
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        {/* Desktop View */}
        <ul className="destopView">
          {/* Documentation */}
          <li
            className={`nav-sub-container ${
              openMenu === "docs" ? "open" : ""
            }`}
            onMouseEnter={() => setOpenMenu("docs")}
            onMouseLeave={closeMenu}
          >
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                e.preventDefault();
                toggleMenu("docs");
              }}
              onFocus={() => setOpenMenu("docs")}
            >
              Documentation
            </a>

            <ul className="nav-sublink">
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={config.jmw_client_docs}
                >
                  Client Documentation
                </a>
              </li>

              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={config.jmw_partner_docs}
                >
                  Partner Documentation
                </a>
              </li>
            </ul>
          </li>

          {/* Resources */}
          <li>
            <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
              Resources
            </NavLink>
          </li>

          {/* Support */}
          <li>
            <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
              Support
            </NavLink>
          </li>

          {/* Get Started */}
          <li>
            <NavLink
              exact
              activeClassName="active"
              to={RoutesUrl.TermsAndConditions}
              className="btn"
            >
              Get Started
            </NavLink>
          </li>

          {/* Logout */}
          <li onClick={logout}>
            <Link to="#">
              <i className="edel-icon-logout"></i>
              Logout
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default HeaderUnTnc;